// EW Pass - StickyTopBar
function StickyTopBar() {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-600 via-red-500 to-red-600 text-white py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
        <img
          src="https://static.lumi.new/eb/ebf36b0bd82998b26de00c29a09e6ecc.webp"
          alt="ComproPay"
          className="h-5 sm:h-6 object-contain brightness-0 invert"
        />
        <span className="text-xs sm:text-sm font-semibold tracking-wide">Parceria Exclusiva</span>
      </div>
    </div>
  );
}

export default StickyTopBar;